/**
 * Idle tab nudge — mirrors Grid-Logic-Website TabManager.
 * Cycles document title + favicon when the user leaves the tab.
 */
(function () {
  const assets = window.tabManagerAssets || {};
  const yellowFlag = assets.yellow;
  const redFlag = assets.red;
  const greenFlag = assets.green;

  if (!yellowFlag || !redFlag || !greenFlag) return;

  let timeoutId = null;
  let originalTitle = '';
  let originalFavicon = '';

  const changeFavicon = (href) => {
    const icons = document.querySelectorAll("link[rel*='icon']");
    const cacheBusted = `${href}${href.includes('?') ? '&' : '?'}v=${Date.now()}`;

    if (icons.length > 0) {
      icons.forEach((icon) => {
        icon.href = cacheBusted;
      });
    } else {
      const link = document.createElement('link');
      link.rel = 'icon';
      link.href = cacheBusted;
      document.head.appendChild(link);
    }
  };

  const handleVisibilityChange = () => {
    if (timeoutId) clearTimeout(timeoutId);

    if (document.hidden) {
      document.title = 'BOX BOX BOX! 🏎️';
      changeFavicon(yellowFlag);

      timeoutId = setTimeout(() => {
        document.title = 'Precision Logic. Return to the Grid... 🏁';
        changeFavicon(redFlag);

        timeoutId = setTimeout(() => {
          document.title = 'Your next setup is waiting... 🛠️';
          changeFavicon(greenFlag);
        }, 30000);
      }, 15000);
    } else {
      document.title = originalTitle;
      if (originalFavicon) changeFavicon(originalFavicon);
    }
  };

  const init = () => {
    originalTitle = document.title;

    const existingIcon = document.querySelector("link[rel*='icon']");
    originalFavicon = existingIcon?.href || '';

    document.addEventListener('visibilitychange', handleVisibilityChange);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
